<app-image
  [fileid]="id()"
  [ngStyle]="{ width: size, height: size }"
  [radius]="100"
></app-image>

<ng-content></ng-content>
